const DATE_FORMAT_RECORD = {
  ko: "y\uB144 MMM d\uC77C",
  en: "MMM d, y"
};
const YEAR_DATE_FORMAT_RECORD = {
  ko: "yyyy\uB144",
  en: "yyyy"
};
const YEAR_MONTH_DATE_FORMAT_RECORD = {
  ko: "y\uB144 MMM",
  en: "MMMM, y"
};
const FORMAT_REGEX_PATTERNS = {
  yy: /^\d{2}$/,
  yyyy: /^\d{4}$/,
  "yyyy-MM-dd": /^\d{4}\s*-\s*\d{2}\s*-\s*\d{2}$/,
  "yyyy-MM-d": /^\d{4}\s*-\s*\d{2}\s*-\s*\d{1}$/,
  "yyyy-M-dd": /^\d{4}\s*-\s*\d{1}\s*-\s*\d{2}$/,
  "yyyy-M-d": /^\d{4}\s*-\s*\d{1}\s*-\s*\d{1}$/,
  "yyyy-MM": /^\d{4}\s*-\s*\d{2}$/,
  "yyyy-M": /^\d{4}\s*-\s*\d{1}$/,
  "yy-MM-dd": /^\d{2}\s*-\s*\d{2}\s*-\s*\d{2}$/,
  "yy-MM-d": /^\d{2}\s*-\s*\d{2}\s*-\s*\d{1}$/,
  "yy-M-dd": /^\d{2}\s*-\s*\d{1}\s*-\s*\d{2}$/,
  "yy-M-d": /^\d{2}\s*-\s*\d{1}\s*-\s*\d{1}$/,
  "yy-MM": /^\d{2}\s*-\s*\d{2}$/,
  "yy-M": /^\d{2}\s*-\s*\d{1}$/,
  "yyyy/MM/dd": /^\d{4}\s*\/\s*\d{2}\s*\/\s*\d{2}$/,
  "yyyy/MM/d": /^\d{4}\s*\/\s*\d{2}\s*\/\s*\d{1}$/,
  "yyyy/M/dd": /^\d{4}\s*\/\s*\d{1}\s*\/\s*\d{2}$/,
  "yyyy/M/d": /^\d{4}\s*\/\s*\d{1}\s*\/\s*\d{1}$/,
  "yyyy/MM": /^\d{4}\s*\/\s*\d{2}$/,
  "yyyy/M": /^\d{4}\s*\/\s*\d{1}$/,
  "yy/MM/dd": /^\d{2}\s*\/\s*\d{2}\s*\/\s*\d{2}$/,
  "yy/MM/d": /^\d{2}\s*\/\s*\d{2}\s*\/\s*\d{1}$/,
  "yy/M/dd": /^\d{2}\s*\/\s*\d{1}\s*\/\s*\d{2}$/,
  "yy/M/d": /^\d{2}\s*\/\s*\d{1}\s*\/\s*\d{1}$/,
  "yy/MM": /^\d{2}\s*\/\s*\d{2}$/,
  "yy/M": /^\d{2}\s*\/\s*\d{1}$/,
  "yyyy.MM.dd": /^\d{4}\s*\.\s*\d{2}\s*\.\s*\d{2}$/,
  "yyyy.MM.d": /^\d{4}\s*\.\s*\d{2}\s*\.\s*\d{1}$/,
  "yyyy.M.dd": /^\d{4}\s*\.\s*\d{1}\s*\.\s*\d{2}$/,
  "yyyy.M.d": /^\d{4}\s*\.\s*\d{1}\s*\.\s*\d{1}$/,
  "yyyy.MM": /^\d{4}\s*\.\s*\d{2}$/,
  "yyyy.M": /^\d{4}\s*\.\s*\d{1}$/,
  "yy.MM.dd": /^\d{2}\s*\.\s*\d{2}\s*\.\s*\d{2}$/,
  "yy.MM.d": /^\d{2}\s*\.\s*\d{2}\s*\.\s*\d{1}$/,
  "yy.M.dd": /^\d{2}\s*\.\s*\d{1}\s*\.\s*\d{2}$/,
  "yy.M.d": /^\d{2}\s*\.\s*\d{1}\s*\.\s*\d{1}$/,
  "yy.MM": /^\d{2}\s*\.\s*\d{2}$/,
  "yy.M": /^\d{2}\s*\.\s*\d{1}$/,
  yyyyMMdd: /^\d{4}\s*\d{2}\s*\d{2}$/,
  yyyyMMd: /^\d{4}\s*\d{2}\s*\d{1}$/,
  yyyyMdd: /^\d{4}\s*\d{1}\s*\d{2}$/,
  yyyyM: /^\d{4}\s*\d{1}$/,
  yyMMdd: /^\d{2}\s*\d{2}\s*\d{2}$/,
  yyyyMd: /^\d{4}\s*\d{1}\s*\d{1}$/,
  yyMMd: /^\d{2}\s*\d{2}\s*\d{1}$/,
  yyMdd: /^\d{2}\s*\d{1}\s*\d{2}$/,
  yyMd: /^\d{2}\s*\d{1}\s*\d{1}$/,
  yyMM: /^\d{2}\s*\d{2}$/,
  yyM: /^\d{2}\s*\d{1}$/,
  yyyy\uB144MM\uC6D4dd\uC77C: /^\d{4}\s*년\s*\d{2}\s*월\s*\d{2}\s*일$/,
  yyyy\uB144MM\uC6D4d\uC77C: /^\d{4}\s*년\s*\d{2}\s*월\s*\d{1}\s*일$/,
  yyyy\uB144M\uC6D4dd\uC77C: /^\d{4}\s*년\s*\d{1}\s*월\s*\d{2}\s*일$/,
  yyyy\uB144M\uC6D4d\uC77C: /^\d{4}\s*년\s*\d{1}\s*월\s*\d{1}\s*일$/,
  yyyy\uB144MM\uC6D4: /^\d{4}\s*년\s*\d{2}\s*월$/,
  yyyy\uB144M\uC6D4: /^\d{4}\s*년\s*\d{1}\s*월$/,
  yy\uB144MM\uC6D4dd\uC77C: /^\d{2}\s*년\s*\d{2}\s*월\s*\d{2}\s*일$/,
  yy\uB144MM\uC6D4d\uC77C: /^\d{2}\s*년\s*\d{2}\s*월\s*\d{1}\s*일$/,
  yy\uB144M\uC6D4dd\uC77C: /^\d{2}\s*년\s*\d{1}\s*월\s*\d{2}\s*일$/,
  yy\uB144M\uC6D4d\uC77C: /^\d{2}\s*년\s*\d{1}\s*월\s*\d{1}\s*일$/,
  yy\uB144MM\uC6D4: /^\d{2}\s*년\s*\d{2}\s*월$/,
  yy\uB144M\uC6D4: /^\d{2}\s*년\s*\d{1}\s*월$/,
  yy\uB144: /^\d{2}\s*년$/,
  yyyy\uB144: /^\d{4}\s*년$/
};

export { DATE_FORMAT_RECORD, FORMAT_REGEX_PATTERNS, YEAR_DATE_FORMAT_RECORD, YEAR_MONTH_DATE_FORMAT_RECORD };
//# sourceMappingURL=date-format.mjs.map
